export const spacing = {
  50: "2px",
  100: "4px",
  150: "6px",
  200: "8px",
  400: "16px",
  500: "20px",
  600: "24px",
  700: "28px",
  800: "32px",
  850: "36px",
  900: "40px",
  1000: "48px",
  1150: "60px",
  1200: "64px",
  1300: "72px",
  1400: "80px",
} as const;

export const borderRadius = {
  none: "0",
  XS: "2px",
  S: "12px",
  M: "16px",
  L: "20px",
  full: "99999px",
} as const;

export const borderRadiusOptions = Object.entries(borderRadius).map(
  ([key, value]) => ({ value, displayName: `${key} (${value})` }),
);
